export function detectPlanCreationIntent(text) {
    const value = String(text || "").trim();
    if (!value) return false;
    return /(プラン|設計案|確認しながら|曖昧|相談しながら)/.test(value);
}

export function detectFlowCreationIntent(text) {
    const value = String(text || "").trim();
    if (!value) return false;
    return /(フロー|工程|シーケンス|手順).*(作成|生成|作って|つくって|組んで|追加|反映)|(?:作成|生成|作って|つくって|組んで).*(フロー|工程|シーケンス|手順)/.test(value);
}

export function isQuestionLikeText(text) {
    const value = String(text || "").trim();
    if (!value) return false;
    return [
        /ですか[？?]?$/,
        /ますか[？?]?$/,
        /でしょうか[？?]?$/,
        /[？?]$/,
        /のでは[？?]?$/,
        /どのよう/,
        /どう(すれば|やって|設定|割り当て|割付)/,
        /なぜ/,
        /何[がを]?/,
        /必要/,
        /できますか/,
        /足りてない/
    ].some((pattern) => pattern.test(value));
}

export function detectReviewIntent(text) {
    const value = String(text || "").trim();
    if (!value) return false;
    return /(正しい|問題|レビュー|これでいい|このコード|この生成コード)/.test(value);
}

export function detectSettingsHelpIntent(text) {
    const value = String(text || "").trim();
    if (!value) return false;
    return /(CODESYS|codesys|I\/O|IO|マッピング|割り当て|割付|%IX|%QX|AT\s*%|変数.*設定|デバイスツリー|アドレス|番地|入力チャネル|出力チャネル|物理入力|物理出力)/.test(value);
}

export function isStGenerationMode(mode) {
    return mode === "st" || mode === "vendor-conversion";
}

export function classifyAssistantIntent(mode, text) {
    const value = String(text || "").trim();
    if (!value) {
        return { intent: "default", mode };
    }
    if (detectReviewIntent(value)) {
        return { intent: "review", mode: "review" };
    }
    if (isStGenerationMode(mode) && detectSettingsHelpIntent(value) && isQuestionLikeText(value)) {
        return { intent: "settings_help", mode: "qa" };
    }
    if (isStGenerationMode(mode) && isQuestionLikeText(value)) {
        return { intent: "qa", mode: "qa" };
    }
    return { intent: "default", mode };
}

export function isFlowResetIntent(text) {
    return /(新規|作り直し|作りなおし|最初から|ゼロから|やり直し|reset|start over|from scratch)/i.test(
        String(text || "")
    );
}

export function extractAxisNameFromText(text) {
    const value = String(text || "");
    const match = value.match(/([A-Za-z]+|[XYZABC]|第?[0-9]+)\s*軸/);
    if (!match?.[1]) return "";
    return `${match[1]}軸`;
}

export function detectOffBranchFromText(text) {
    const value = String(text || "");
    if (/(OFF|未検知|false).*(待機|再確認)/i.test(value)) return "wait";
    if (/(OFF|未検知|false).*(終了|停止|中断)/i.test(value)) return "end";
    if (/(OFF|未検知|false).*(エラー|異常)/i.test(value)) return "error";
    return "";
}

export function detectAfterMotionFromText(text) {
    const value = String(text || "");
    if (/(次動作|次工程|続けて|その後さらに)/.test(value)) return "next_motion";
    if (/(終了|完了|終わり)/.test(value)) return "end";
    return "";
}

export function extractTimeoutSecFromText(text) {
    const value = String(text || "");
    const match = value.match(/([0-9]+(?:\.[0-9]+)?)\s*秒/);
    return match?.[1] || "";
}

export function extractErrorCodeFromText(text) {
    const value = String(text || "");
    return value.match(/\bE\d{2,4}\b/i)?.[0]?.toUpperCase() || "";
}

export function extractJsonObjectFromText(text) {
    const value = String(text || "").trim();
    if (!value) throw new Error("AI応答が空です。");
    try {
        return JSON.parse(value);
    } catch {
        const fenced = value.match(/```(?:json)?\s*([\s\S]*?)```/i);
        if (fenced?.[1]) return JSON.parse(fenced[1]);
        const start = value.indexOf("{");
        const end = value.lastIndexOf("}");
        if (start >= 0 && end > start) return JSON.parse(value.slice(start, end + 1));
        throw new Error("AI応答からフローJSONを読み取れませんでした。");
    }
}

export function buildFallbackThreadTitle(text) {
    const normalized = String(text || "").replace(/\s+/g, " ").trim();
    if (!normalized) return "新規チャット";
    return normalized.length > 20 ? normalized.slice(0, 20) : normalized;
}
